import type { SVGProps } from 'react';
const DawnFlagCH = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-CH_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-CH_svg__a)">
      <path fill="red" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M9.429 9.6h-2.81a.333.333 0 0 1-.333-.333V6.733c0-.184.15-.333.333-.333h2.81V3.533c0-.184.15-.333.333-.333h2.476c.185 0 .334.15.334.333V6.4h2.81c.184 0 .333.15.333.333v2.534c0 .184-.15.333-.334.333h-2.81v2.867c0 .184-.148.333-.332.333H9.762a.333.333 0 0 1-.333-.333z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagCH;
